import { createSelector } from 'reselect';
import getPropFromModule from './getPropFromModule';
import { USER_TOTAL_ORDERS } from '../model';

const selectUserTotalOrders = createSelector(
  state => getPropFromModule(state, USER_TOTAL_ORDERS),
  userTotalOrders => userTotalOrders && userTotalOrders.toJS(),
);

export default selectUserTotalOrders;
